import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "absolute bottom-0 inset-x-0 px-container pb-16 lg:pb-32" }, [
  /*#__PURE__*/_createVNode("h1", { class: "font-display text-center" }, [
    /*#__PURE__*/_createVNode("div", { class: "mb-4 text-2xl lg:text-4xl" }, "V Edición"),
    /*#__PURE__*/_createVNode("div", { class: "text-6xl lg:text-8xl text-amff-teal" }, "Mallorca")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "mt-4 text-center text-2xl lg:text-4xl font-display" }, " Talents Lab 2022 ")
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" L'Atlàntida Mallorca Film Fest, en la seva dotzena edició, torna a apostar pels joves talents del cinema. "),
  /*#__PURE__*/_createVNode("strong", null, " Amb la col·laboració de Media i Europa Creativa Catalunya "),
  /*#__PURE__*/_createTextVNode(" ,celebrem la V edició del Mallorca Talents Lab, un espai únic a Espanya en el que 18 projectes gaudeixen de l'assessoria dels majors experts de la indústria cinematogràfica europea. ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("p", null, " Del 26 al 28 de Juliol la V edició del Mallorca Talenst Lab reunirà 6 ficcions, 6 documentals i 6 projectes work in progress, seleccionats entre les més de 200 propostes rebudes. ", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, " Aquests projectes rebran la mentoria de noms com els de Miguel Machalski (Billy Elliott), Fernanda Rossi (The Secret of Doctor Grinberg) i programadors de festivals com Cannes, Berlín, Rotterdam, Sevilla, Málaga, Abycine, Gijón i el D' Film Fest. ", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("p", null, "Les obres seleccionades són:", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("strong", null, [
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("u", null, "PROJECTES DE FICCIÓ")
  ]),
  /*#__PURE__*/_createVNode("p", null, "opten al PREMI FILMIN de 40.000€"),
  /*#__PURE__*/_createVNode("ul", null, [
    /*#__PURE__*/_createVNode("li", null, " “Salen las lobas” d. Claudia Estrada Tarascó “Beroa” d. Mario Díaz Delgado "),
    /*#__PURE__*/_createVNode("li", null, " “Laguna el ministro” d. espírituescalera “El taxista de delicias” d. Teresa Carril "),
    /*#__PURE__*/_createVNode("li", null, "“Pequeños calvarios” d. Los Hermanos Polo"),
    /*#__PURE__*/_createVNode("li", null, "“El debate” d. David Ordinas")
  ]),
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("u", null, "PROJECTES DE DOCUMENTAL")
  ]),
  /*#__PURE__*/_createVNode("p", null, "opten al PREMI FILMIN de 15.000€"),
  /*#__PURE__*/_createVNode("ul", null, [
    /*#__PURE__*/_createVNode("li", null, "“Les culpables” d. Marta Durán"),
    /*#__PURE__*/_createVNode("li", null, "“¿Es usted secuestrable?” d. Carlota Bujosa"),
    /*#__PURE__*/_createVNode("li", null, "“Eñaut Zuazo” d. Meritxell Valls"),
    /*#__PURE__*/_createVNode("li", null, "“Los poetas errantes” d. Javier Reyes"),
    /*#__PURE__*/_createVNode("li", null, "“Lionel” d. Carlos Saiz"),
    /*#__PURE__*/_createVNode("li", null, "“Rafael Marín, una deuda cultural” d. Borja Moreno")
  ]),
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("u", null, "PROJECTES WORK IN PROGRESS")
  ]),
  /*#__PURE__*/_createVNode("p", null, "opten al PREMI FILMIN de 10.000€"),
  /*#__PURE__*/_createVNode("ul", null, [
    /*#__PURE__*/_createVNode("li", null, "“Daytona” d. Carmen Pedrero"),
    /*#__PURE__*/_createVNode("li", null, "“Samsara” d. Lois Patiño"),
    /*#__PURE__*/_createVNode("li", null, "“21” d. Néstor Ruiz Medina"),
    /*#__PURE__*/_createVNode("li", null, "“María y la película olvidada” d. Marta Herrero y Nuria Abad"),
    /*#__PURE__*/_createVNode("li", null, " “Negu Hurbilak” d. Ekain Albite, Adrià Roca, Nicolau Mallofré, Mikel Ibarguren "),
    /*#__PURE__*/_createVNode("li", null, "“Remember my name” d. Elena Molina")
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Atlàntida Mallorca Film Fest, en su duodécima edición, vuelve a apostar por los jóvenes talentos del cine. "),
  /*#__PURE__*/_createVNode("strong", null, " Con la colaboración de Media y Europa Creativa Catalunya "),
  /*#__PURE__*/_createTextVNode(" , celebramos la V edición del Mallorca Talents Lab, un espacio único en España en el que 18 proyectos disfrutan de la asesoría de los mayores expertos de la industria cinematográfica europea. ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("p", null, " Del 26 al 28 de julio la V edición del Mallorca Talent Lab reunirá 6 ficciones, 6 documentales y 6 proyectos work in progress, seleccionados entre las más de 200 propuestas recibidas. ", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("p", null, " Estos proyectos recibirán la mentoría de nombres como Miguel Machalski (Billy Elliott), Fernanda Rossi (The Secret of Doctor Grinberg) y programadores de los festivales como Cannes, Berlín, Rotterdam, Sevilla, Málaga, Abycine, Gijón y el D'A Film Fest. ", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("p", null, "Las obras seleccionadas son:", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("strong", null, [
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("u", null, "PROYECTOS DE FICCIÓN")
  ]),
  /*#__PURE__*/_createVNode("p", null, "optan al PREMIO FILMIN de 40.000€"),
  /*#__PURE__*/_createVNode("ul", null, [
    /*#__PURE__*/_createVNode("li", null, "“Salen las lobas” d. Claudia Estrada Tarascó"),
    /*#__PURE__*/_createVNode("li", null, "“Beroa” d. Mario Díaz Delgado"),
    /*#__PURE__*/_createVNode("li", null, "“Laguna el ministro” d. espírituescalera"),
    /*#__PURE__*/_createVNode("li", null, "“El taxista de delicias” d. Teresa Carril"),
    /*#__PURE__*/_createVNode("li", null, "“Pequeños calvarios” d. Los Hermanos Polo"),
    /*#__PURE__*/_createVNode("li", null, "“El debate” d. David Ordinas")
  ]),
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("u", null, "PROYECTOS DE DOCUMENTAL")
  ]),
  /*#__PURE__*/_createVNode("p", null, "optan al PREMIO FILMIN de 15.000€"),
  /*#__PURE__*/_createVNode("ul", null, [
    /*#__PURE__*/_createVNode("li", null, "“Les culpables” d. Marta Durán"),
    /*#__PURE__*/_createVNode("li", null, "“¿Es usted secuestrable?” d. Carlota Bujosa"),
    /*#__PURE__*/_createVNode("li", null, "“Eñaut Zuazo” d. Meritxell Valls"),
    /*#__PURE__*/_createVNode("li", null, "“Los poetas errantes” d. Javier Reyes"),
    /*#__PURE__*/_createVNode("li", null, "“Lionel” d. Carlos Saiz"),
    /*#__PURE__*/_createVNode("li", null, "“Rafael Marín, una deuda cultural” d. Borja Moreno")
  ]),
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("u", null, "PROYECTOS WORK IN PROGRESS")
  ]),
  /*#__PURE__*/_createVNode("p", null, "optan al PREMIO FILMIN de 10.000€"),
  /*#__PURE__*/_createVNode("ul", null, [
    /*#__PURE__*/_createVNode("li", null, "“Daytona” d. Carmen Pedrero"),
    /*#__PURE__*/_createVNode("li", null, "“Samsara” d. Lois Patiño"),
    /*#__PURE__*/_createVNode("li", null, "“21” d. Néstor Ruiz Medina"),
    /*#__PURE__*/_createVNode("li", null, "“María y la película olvidada” d. Marta Herrero y Nuria Abad"),
    /*#__PURE__*/_createVNode("li", null, " “Negu Hurbilak” d. Ekain Albite, Adrià Roca, Nicolau Mallofré, Mikel Ibarguren "),
    /*#__PURE__*/_createVNode("li", null, "“Remember my name” d. Elena Molina")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Hero = _resolveComponent("Hero")
  const _component_PageTitle = _resolveComponent("PageTitle")
  const _component_PageContent = _resolveComponent("PageContent")
  const _component_PageContainer = _resolveComponent("PageContainer")
  const _component_FollowFestival = _resolveComponent("FollowFestival")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Hero, null, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_PageContainer, null, {
      default: _withCtx(() => [
        _createVNode(_component_PageTitle),
        (_ctx.currentLang === 'cat')
          ? (_openBlock(), _createBlock(_component_PageContent, { key: 0 }, {
              default: _withCtx(() => [
                _hoisted_2,
                _hoisted_3,
                _hoisted_4,
                _hoisted_5,
                _hoisted_6
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_PageContent, { key: 1 }, {
              default: _withCtx(() => [
                _hoisted_7,
                _hoisted_8,
                _hoisted_9,
                _hoisted_10,
                _hoisted_11
              ]),
              _: 1
            }))
      ]),
      _: 1
    }),
    _createVNode(_component_FollowFestival)
  ], 64))
}